import type * as React from "react"

import { SidebarInset } from "@/components/ui/sidebar"

type AppContentProps = {
  variant?: "header" | "sidebar"
} & React.ComponentProps<"main">

export function AppContent({
  variant = "header",
  children,
  ...props
}: AppContentProps) {
  if (variant === "sidebar") {
    return <SidebarInset {...props}>{children}</SidebarInset>
  }

  return (
    <main className="flex h-full w-full flex-1 flex-col gap-4" {...props}>
      {children}
    </main>
  )
}
